


































import { Getter } from "vuex-class";
import { Component, Prop, Vue } from "vue-property-decorator";
import ShiftRender from "@/components/render/ShiftRender.vue";
import MenuRender from "@/components/render/MenuRender.vue";
import StageRender from "@/components/render/StageRender.vue";
import { RenderContentModel, Button, RenderStageModel } from "@/services/render/types";
import { InteractionTypes, isShift } from "@/services/channels/types";
import { RenderEventBus } from "@/render-event-bus";
import { FILEENDPOINT } from "@/app.config";
import SessionRender from "@/solutionTypes/sessions/SessionRender.vue";
import { TemplateTypeEnum } from "@/services/templates/types";
import { SessionRenderTemplateModel } from "@/solutionTypes/sessions/types";

@Component({
    name: "content-render-component",
    components: {
        ShiftRender,
        MenuRender,
        StageRender,
        SessionRender
    }
})
export default class ContentRenderComponent extends Vue {
    @Getter("preview/getPreviewControlsStatus") previewControlStatus!: boolean;
    @Prop() private contentRenderModel!: SessionRenderTemplateModel;
    @Prop({ default: true }) preview!: boolean;
    @Prop({ default: "" }) highlightId!: string;
    @Prop() solutionProperties!: any;
    dateTime = new Date();

    interactionTypes = InteractionTypes;
    isShift = isShift;
    useStageExpandedDimensions = false as boolean;

    emitEvent(eventName: string) {
        RenderEventBus.$emit(eventName);
    }

    // computed
    get dynamicStyle() {
        return {
            height: `${this.contentRenderModel.height}px`,
            width: `${this.contentRenderModel.width}px`
        };
    }

    get showBorder() {
        return this.previewControlStatus;
    }

    get sessionModel() {
        if (this.contentRenderModel.type && this.contentRenderModel.type === TemplateTypeEnum.sessions) return true;
        return false;
    }

    // methods
    buttonStyle(button: Button) {
        let style = `width: ${button.width}px; height: ${button.height}px; ${button.css.button}`;
        if (button.imageId !== undefined && button.imageId !== "") {
            style += `;background-color: transparent; background-image: url("${this.getFileSrc(button.imageId)}");`;
        }
        return style;
    }

    getContentStyle(model: RenderContentModel) {
        return {
            position: "absolute",
            top: `${model.ypos}px`,
            left: `${model.xpos}px`,
            "z-index": model.layer
        };
    }

    getStageStyle(model: RenderStageModel) {
        if (this.useStageExpandedDimensions) {
            return {
                position: "absolute",
                top: `0px`,
                left: `0px`,
                "z-index": model.layer
            };
        } else {
            return {
                position: "absolute",
                top: `${model.ypos}px`,
                left: `${model.xpos}px`,
                "z-index": model.layer
            };
        }
    }

    getButtonUISettings(button: Button) {
        return {
            position: "absolute",
            top: `${button.y}px`,
            left: `${button.x}px`,
            "z-index": button.layer
        };
    }

    getFileSrc(fileId: string): string {
        return `${FILEENDPOINT}${fileId}`;
    }

    onExpandedDimensionsChange(expandedDimensions: boolean) {
        // alert(expandedDimensions);
        this.useStageExpandedDimensions = expandedDimensions;
    }
}
